import { Utils } from "./common/utils";
import * as $ from "jquery";
import * as Backbone from "backbone";
import * as _ from "lodash";
import * as Highcharts from "highcharts";
import * as moment from "moment-timezone";
import Auth from '@aws-amplify/auth';
import { AppRouter } from "./router";
import { Hub } from '@aws-amplify/core'

require("../less/bundle.less");

// Global References to jQuery, lodash, highcharts, and moment to make debugging easier
window['$'] = $;
window['_'] = _;
window['Highcharts'] = Highcharts;
window['moment'] = moment;

// IE polyfills
require('ie-shim');
if (!window['Promise']) window['Promise'] = require('lib/Promise.min');

// Spectrum color picker JQuery Plugin
require('spectrum');

// Setup High charts plugins
var HighchartsMore = require('highcharts.more');
HighchartsMore(Highcharts);
var HighchartsExporting = require('highcharts.exporting');
HighchartsExporting(Highcharts);
var HighchartsExportingCSV = require('highcharts.export.csv');
HighchartsExportingCSV(Highcharts);
var HighchartsHeatMap = require('highcharts.heatmap');
HighchartsHeatMap(Highcharts);
var HighchartsNoData = require('highstock.nodata');
HighchartsNoData(Highcharts);

declare const CONFIG: any;
declare var App: any;
App = window['App'] = {
    // Git Version
    Version: null,

    // Global Message Bus
    Bus: _.extend({}, Backbone.Events),

    // Backbone Router Instance
    Router: null,


    getLastSelectedInstallId: () => {
        return <number>Number(localStorage.getItem('lastSelectedInstallId'))
    },
    setLastSelectedInstallId: (id: number) => {
        localStorage.setItem('lastSelectedInstallId', String(id));
    },
    getLastSelectedModuleNumber: () => {
        return <string>localStorage.getItem('lastSelectedModuleNumber')
    },
    setLastSelectedModuleNumber: (num: string) => {
        localStorage.setItem('lastSelectedModuleNumber', String(num));
    },
    getLastSelectedModuleId: () => {
        var lastSelectedModuleId = localStorage.getItem('lastSelectedModuleId');
        return lastSelectedModuleId ? Number(lastSelectedModuleId) : null;
    },
    setLastSelectedModuleId: (num: number) => {
        localStorage.setItem('lastSelectedModuleId', String(num));
    },

    // Check for SSO signin which triggers after we detect that the user must sign in
    waitForIdToken() {
        var d = $.Deferred();
        var interval = setInterval(() => {
            var prefix = `CognitoIdentityServiceProvider.${CONFIG.cognito.userPoolWebClientId}`;
            var user = localStorage.getItem(`${prefix}.LastAuthUser`);
            var token = localStorage.getItem(`${prefix}.${user}.idToken`);

            if (token) {
                clearInterval(interval);
                d.resolve(token);
            }
        }, 200);

        return d;
    }
};

// Bootstrap collapse without transition
require('bootstrap');
(<any>$.fn).collapse.Constructor.OLD_TRANSITION_DURATION = (<any>$.fn).collapse.Constructor.TRANSITION_DURATION;
(<any>$.fn).collapse.Constructor.TRANSITION_DURATION = 0;

_.extend(CONFIG.cognito.oauth, {
    redirectSignIn: window.location.origin,
    redirectSignOut: window.location.origin
});
Auth.configure(CONFIG.cognito);

// Start the app by instatiating the router
App.Router = new AppRouter();

Hub.listen('auth', (data) => {
    switch (data.payload.event) {
        case 'signIn_failure':
            // we want to keep recent visits to dashboard and reports
            const savedRecentDashboards = localStorage.getItem("recentDashboards");
            const savedRecentReports = localStorage.getItem("recentReports");

            localStorage.clear();
            sessionStorage.clear();

            // re-save recent visits to dashboard and reports
            if (savedRecentDashboards) localStorage.setItem("recentDashboards", savedRecentDashboards);
            if (savedRecentReports) localStorage.setItem("recentReports", savedRecentReports);
            break;
        case 'signIn':
            var nextUrl = sessionStorage.getItem('loginNextView');
            $.when(App.waitForIdToken()).then((token) => {
                window.location.hash = nextUrl;
                sessionStorage.setItem('loginNextView', '');
                window.location.reload();
            });
            break;
        case 'signOut':
            break;
    }
});


// Hacky fix for a bug in select2 with jQuery new nested-focus "protection"
// Autofocus on input search field whenever a select2 element is opened
$(document).on('select2:open', () => {
    let allFound = document.querySelectorAll<HTMLInputElement>('.select2-container--open .select2-search__field');
    allFound[allFound.length - 1].focus();
});



// WEBPACK FOOTER //
// ./srv/public/js/app.ts